<template>
  <div>
    <v-responsive
      class="overflow-y-auto"
    >
      <!-- <FeaturesOverview /> -->

      <FeaturesList />

      <!-- CRMs List -->
      <v-responsive
        class="text-center "
      >
        <v-lazy
          v-model="crmsIsActive"
          :options="{
            threshold: .5
          }"
          min-height="200"
          transition="fade-transition"
        >
          <div class="pa-4 text-left">
            <div class="text-h5 text-left">{{ $t('about.crms.selectCrm') }}</div>
            <v-card
              class="d-flex justify-space-around flex-wrap mt-4 mb-2"
              flat
              tile
            >
              <v-hover  
                v-for="(item, index) in crmsList"
                :key="index"
                v-slot="{ hover }"
              >
                <v-card
                  @click="crmDialogOpen(item)"
                  :elevation="hover ? 16 : 2"
                  :class="{ 'on-hover': hover }"
                  class="pa-2 ma-4"
                  max-height="260"
                  height="260"
                  width="240"
                  max-width="250"
                  elevated
                >
                  <v-card-title class="d-flex justify-center">
                    {{ item.title }}
                  </v-card-title>
                  <v-divider />
                  <v-card-text class="d-flex justify-center fit" style="width: 100%">
                    <v-img
                      class="shrink mr-2"
                      contain
                      :src="require('../assets/'+ item.img)"
                      transition="scale-transition"
                      height="150"
                    />
                  </v-card-text>

                </v-card>
              </v-hover>
            </v-card>
          </div>
        </v-lazy>

        <!-- Platforms -->
        <v-lazy
          v-model="platformsIsActive"
          :options="{
            threshold: .5
          }"
          min-height="200"
          transition="fade-transition"
        >
          <FeaturesPlatforms />
        </v-lazy>

      </v-responsive>
    </v-responsive>

    <!-- Dialogs -->
    <FeaturesCrmDialog
      v-if="crmDialog"
      @close-dialog="crmDialogClose"
      :showCrmDialog="true"
      :selectedCrm="selectedCrm"
    />

    <!-- Login Link -->
    <!-- <p class="mx-auto mt-3" :class="{ 'pb-5': $vuetify.breakpoint.xs }">
      {{ $t('registration.alreadyAccount') }} <router-link to="/login">{{ $t('login.login') }}</router-link>
    </p> -->

    <!-- Start Trial / Registartion Link -->
    <v-row
      align="center"
      justify="center"
      class="mb-2"
    >
      <!-- <router-link to="/registration" class="font-weight-black start-trial">{{ $t('registration.panel.startTrial') }} </router-link> -->
      <v-btn
        to="/registration"
        color="#F2A81D"
        flat
      >
        <span class="font-weight-black start-trial">{{ $t('registration.panel.startTrial') }}</span>
      </v-btn>
    </v-row>
  </div>
</template>

<script>
  import i18n from '../i18n';

  export default {
    components: {
      FeaturesCrmDialog: () => import('@/components/FeaturesCrmDialog'),
      FeaturesList: () => import('@/components/FeaturesList'),
      FeaturesPlatforms: () => import('@/components/FeaturesPlatforms'),
      // FeaturesOverview: () => import('@/components/FeaturesOverview'),
    },
    data: () => ({
      crmDialog: false,
      selectedCrm: {},

      crmsIsActive: false,
      platformsIsActive: false,
      crmsList: [
        { 
          title: i18n.t('about.crms.dynamics.title'), 
          img: 'logo_dynamics.png',
          status: 'done',
          crmFeatures: [
            { title: i18n.t('about.crms.dynamics.searchTitle'), description: 'The Search feature allows the agent to search and retrieve Contact, Lead and Account type records from MS Dynamics CRM based on the “search string” entered on Widget.' },
            { title: 'Create and Update Contact type record', description: 'This feature allows the creation of Contacts within Dynamics directly through the Widget. The Agent is able to create and edit Contact with Standard (Required) fields and Custom fields.' },
            { title: 'Create and Update Lead type record', description: 'This feature allows the creation of Leads within Dynamics directly through the Widget. The Agent is able to create and edit Lead with Standard (Required) fields and Custom fields.' },
            { title: 'Create and Update Account type record', description: 'This feature allows the creation of Accounts within Dynamics directly through the Widget. The Agent is able to create and edit Account with Standard (Required) fields and Custom fields.' },
            { 
              title: 'Associate Messaging Transcript for Lead, Account and Contact type record', 
              description: 'The Engagement messaging transcription will be associated with that relevant record in MS Dynamics', 
              subItems: [
                "Associate Transcript as Note (Annotation), Task, or Case (Incident) to Account type record",
                "Associate Transcript as Note (Annotation), Task or Case (Incident) to Contact type record",
                "Associate Transcript as Note (Annotation) or Task to Lead type record"
              ]
            },
           { 
              title: i18n.t('about.features.personalization'), 
              description: i18n.t('about.features.personalizationDescription'),
              subItems: [
                "Add up to 10 fields of your choice",
                "Use Microsoft Dynamics Standard Fields or Custom Fields",
                "You can add custom information to your MS Dynamics record directly from the Widget",
                "Customize your Account, Contact and Lead form according to your needs"
              ]
            }
          ]
        },
        { 
          title: 'Zendesk', 
          img: 'logo_zendesk.png',
          status: 'done',
          crmFeatures: [
            { title: 'Search Feature', description: 'The Search feature allows the agent to search and retrieve Tickets and End Users from Zendesk CRM based on the "search string" entered on Widget.' },
            { title: 'Create End-User', description: 'This feature allows the creation of End-Users within Zendesk directly through the Widget. The Agent is able to create End User with Standard (Required) fields and Custom fields.' },
            { title: 'Update End-User', description: 'The Agent can update the information of an existing End-User record in Zendesk directly through the Widget.' },
            { title: 'Create Ticket ', description: 'The Create Ticket feature allows the creation of Tickets within Zendesk directly through the Widget. The Agent is able to create a Ticket in the Zendesk system with Standard (Required) fields and Custom fields.' },
            { title: 'Update Ticket ', description: 'The Agent is able to update a Ticket in the Zendesk system and add public or private comments to the ticket.' },
            { 
              title: 'Attach the Messaging Transcript for Ticket type record', 
              description: 'The Engagement messaging transcription will be linked to that relevant record in Zendesk as a Comment.', 
            },
            { 
              title: i18n.t('about.features.personalization'), 
              description: i18n.t('about.features.personalizationDescription'),
              subItems: [
                "Add up to 10 fields of your choice",
                "Use Zendesk Standard Fields or Custom Fields",
                "You can add custom information such as Tags to your Zendesk record directly from the Widget",
                "Customize your End-User and Ticket form according to your needs"
              ]
            }
          ]
        },
        { 
          title: 'Salesforce', 
          img: 'logo_salesforce.png', 
          status: 'done',
          crmFeatures: [
            { title: 'Search Feature', description: 'The Search feature allows the agent to search and retrieve Account, Contact, Lead and Opportunity type records from Salesforce based on the “search string” entered on Widget.' },
            { title: 'Create and Update Account type record', description: 'This feature allows the creation of Accounts within Salesforce directly through the Widget. The Agent is able to create and edit Account with Standard (Required) fields and Custom fields.' },
            { title: 'Create and Update Contact type record', description: 'This feature allows the creation of Contacts within Salesforce directly through the Widget. The Agent is able to create and edit Contact with Standard (Required) fields and Custom fields.' },
            { title: 'Create and Update Lead type record', description: 'This feature allows the creation of Leads within Salesforce directly through the Widget. The Agent is able to create and edit Lead with Standard (Required) fields and Custom fields.' },
            { title: 'Create and Update Opportunity type record', description: 'This feature allows the creation of Opportunities within Salesforce directly through the Widget. The Agent is able to create and edit Opportunity with Standard (Required) fields and Custom fields.' },
            { 
              title: 'Associate Messaging Transcript for Account and Contact type record', 
              description: 'The Engagement messaging transcription will be associated with that relevant record in Salesforce', 
              subItems: [
                "Associate Transcript as Case to Account type record",
                "Associate Transcript as Case to Contact type record"
              ]
            },
           { 
              title: i18n.t('about.features.personalization'), 
              description: i18n.t('about.features.personalizationDescription'),
              subItems: [
                "Add up to 10 fields of your choice",
                "Use Salesforce Standard Fields or Custom Fields",
                "You can add custom information to your Salesforce record directly from the Widget",
                "Customize your Account, Contact, Lead and Opportunity form according to your needs"
              ]
            }
          ]
        }
      ],
    }),
    methods: {
      crmDialogOpen(crm) {
        this.crmDialog = true
        this.selectedCrm = crm
      },
      crmDialogClose() {
        this.crmDialog = false
        this.selectedCrm = {}
      },
    }
  }
</script>

<style>
.subitem {
  font-size: 10px;
  font-weight: 400;
}

.start-trial{
  /* color: #F2A81D; */
  color: #173862;
}
</style>